import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import throttle from 'lodash.throttle';
import { GlobalStyles } from 'twin.macro';
import { BrowserRouter } from 'react-router-dom';

import store from './store';
import App from './App';
import { saveState } from './reducers/localStorage';

// persist state to localstorage
store.subscribe(
  throttle(() => {
    const state = store.getState();
    saveState({
      portfolioReducer: state.portfolioReducer,
      backupReducer: state.backupReducer,
      settingsReducer: state.settingsReducer,
    });
  }, 1000)
);

function renderApp() {
  let container = document.getElementById('root');
  if (!container) {
    container = document.createElement('div');
    container.id = 'root';
    document.body.appendChild(container);
  }

  const root = ReactDOM.createRoot(container);
  root.render(
    <>
      <GlobalStyles />
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </>
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}
